import { render, staticRenderFns } from "./investigate-arrears.vue?vue&type=template&id=4ba48f74&scoped=true"
import script from "./investigate-arrears.vue?vue&type=script&lang=js"
export * from "./investigate-arrears.vue?vue&type=script&lang=js"
import style0 from "./investigate-arrears.vue?vue&type=style&index=0&id=4ba48f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba48f74",
  null
  
)

export default component.exports